import request from '@/utils/request'


export function getBillList(query) {
  return request({
    url: '/api/common/v1/order/selectOrderList',
    method: 'get',
    params: query
  })
}




